import { Navigate } from "react-router-dom";

const AdminOnly = ({ children }) => {
  let id = localStorage.getItem("access");

  if (id != process.env.REACT_APP_ADMIN_ID) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export { AdminOnly };
